export default "__VITE_ASSET__y4jJNujq__"